import * as React from 'react';
import { FormGroup, Label, Input } from '../../../components/Bootstrap';
import { CenterModel } from '../types';

type NameEditorProps = {
  data: CenterModel;
  onChange(data: CenterModel);
};

export const NameEditor: React.FC<NameEditorProps> = (props) => {
  const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    props.onChange({
      ...props.data,
      name: e.target.value,
    });
  };

  return (
    <FormGroup className='fulfillment-center-modal-input'>
      <Label>Station name</Label>
      <Input value={props.data.name} onChange={onChange} placeholder='E.g. 2nd floor bar' required={true} />
    </FormGroup>
  );
};
